import { render, staticRenderFns } from "./Explain.vue?vue&type=template&id=23ff8e9c&"
import script from "./Explain.vue?vue&type=script&lang=js&"
export * from "./Explain.vue?vue&type=script&lang=js&"
import style0 from "./Explain.vue?vue&type=style&index=0&id=23ff8e9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports